import CryptoJS from "crypto-js";
import { createTransform } from "redux-persist";

// const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

// Load or generate secret key
let SECRET_KEY = localStorage.getItem("redux_secret_key");

if (!SECRET_KEY) {
  // Generate 256-bit random key (32 bytes)
  SECRET_KEY = CryptoJS.lib.WordArray.random(32).toString();
  localStorage.setItem("redux_secret_key", SECRET_KEY);
} else {
  // console.log("Loaded existing secret key");
}

export const encryptTransform = createTransform(
  // Outgoing: State → Storage
  (inboundState) => {
    if (!inboundState || !inboundState.loggedInUserDetails) {
      return undefined; // ⛔ do not persist auth before login
    }

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(inboundState),SECRET_KEY).toString();
    } catch (err) {
      // console.error("::Encryption error:", err);
      return undefined;
    }
  },

  // Incoming: Storage → State
  (outboundState) => {
    if (!outboundState || typeof outboundState !== "string") {
      return {}; // reducer starts fresh if nothing in storage
    }

    try {
      const bytes = CryptoJS.AES.decrypt(outboundState, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted ? JSON.parse(decrypted) : {};
    } catch (err) {
      // console.error("Decryption error:", err);
      return {};
    }
  },
  { whitelist: ["auth"] }
);